export const SUPPORT_EMAIL = "support@talkingalarmclockapp.com";
